/* @flow */
import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import FlipMove from 'react-flip-move'

import UpcomingItem from '../UpcomingItem'
import PlaceholderItems from '../PlaceholderItems'
import { TextRow, Circle, Line } from '../Placeholders'

import './Upcoming.css'
import { isDevice } from '../../helpers/device'

// Show a short list; 'Show more' opens the rest (up to 15)
const UP_NEXT_SHORT = 6
const UP_NEXT_COUNT = 15

export type OwnProps = {
  maxCount: number
}

export type Props = {
  onRemoveTrack: (uuid: string) => void,
  onNextTrack: (uuid: string) => void,
  onDislikeTrack: (uuid: string) => void,
  onDownloadedClick: () => void
}

class Upcoming extends Component<Props> {
  state = { expanded: false }

  render () {
    const { playlistStore, onRemoveTrack, onDislikeTrack, onNextTrack, onDownloadedClick } = this.props
    const { tracks, isLoading, maxTrackCount} = playlistStore
    const { expanded } = this.state
    const upNext = tracks
      .filter((track, index) => (
        !(track.type === 'gymname' && index !== 0)
      ))
      .slice(1, Math.min(maxTrackCount, UP_NEXT_COUNT + 1)) // the playing track is shown above
    // Phones, tablets and the installed app get the short list; desktop shows them all
    const compact = isDevice()
    const shown = expanded || !compact ? upNext : upNext.slice(0, UP_NEXT_SHORT)

    return (
      <div className="upcoming">
        <h4 className="upcoming__heading">Up next</h4>
        { isLoading && (
            <PlaceholderItems count={ compact ? Math.min(maxTrackCount, UP_NEXT_SHORT) : maxTrackCount } />
          )
        }
        <FlipMove
          className="upcoming__list"
          duration={300}
          easing="ease-out"
          enterAnimation="fade"
          leaveAnimation={ null }
          typeName="ul"
        >
          {
            shown.map((track, index) => {
                const iconType = track.type
                return (
                  <UpcomingItem
                    id={ index }
                    key={ track.id }
                    track={ track }
                    iconType={ iconType }
                    onRemoveTrack={ onRemoveTrack }
                    onDownloadedClick={ onDownloadedClick }
                    onDislikeTrack={ onDislikeTrack }
                    onNextTrack={ onNextTrack }
                  />
                )
              })
          }
        </FlipMove>
        {
          compact && upNext.length > UP_NEXT_SHORT && (
            <button
              type="button"
              className="upcoming__more"
              aria-expanded={ expanded }
              onClick={ () => this.setState({ expanded: !expanded }) }
            >
              { expanded ? 'Show less' : `Show ${upNext.length - UP_NEXT_SHORT} more` }
            </button>
          )
        }
      </div>
    )
  }
}

export default inject((stores) => ({
  playlistStore: stores.playlistStore
}))(
  observer(Upcoming)
)